import { formatDistanceToNow } from "date-fns";
import { getLocaleByLanguage } from "./get-locale-by-language";

export function diffForHumans(date: Date, languageCode: string): string {
  const locale = getLocaleByLanguage(languageCode);
  return formatDistanceToNow(date, { addSuffix: true, locale })
}
